import { PropertyIcons } from '../schema/PropertyIcons';

/**
 * @returns the messageClassIcon if it is not included in the RsvpUnit otherwise returns null
 * @param showRSVPUnit tells whether to show RsvpUnit
 * @param messageClassIcon message class icon type
 */
export const getFilteredMessageClassIcon = (
    showRSVPUnit: boolean,
    messageClassIcon: PropertyIcons
) => {
    if (!showRSVPUnit) {
        return messageClassIcon;
    }

    if (
        [
            PropertyIcons.MailListViewAppointmentItem,
            PropertyIcons.MailListViewAppointmentCanceled,
        ].includes(messageClassIcon)
    ) {
        return null;
    }

    return messageClassIcon;
};
